import React from 'react';
import { motion } from 'framer-motion'; // Ensure framer-motion is installed
import styles from './FounderSection.module.css';
import { FaYoutube, FaFacebookF, FaInstagram } from 'react-icons/fa';

const FounderSection = () => {
  // Animation Variants
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8, x: -50 },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, staggerChildren: 0.2 }
    }
  };

  const childVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } }
  };

  return (
    <section className={styles.container}>
      <motion.div
        className={styles.wrapper}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }} // Triggers when 10% visible
      >

        {/* Left Side: Founder Image with Zoom-Fade */}
        <motion.div className={styles.imageContainer} variants={imageVariants}>
          <img
            src="/images/founder.jpeg"
            alt="ZFoundation Founder"
            className={styles.founderImg}
          />
        </motion.div>

        {/* Right Side: Details Content with Staggered Slide */}
        <motion.div className={styles.detailsContent} variants={textVariants}>
          <div className={styles.profileContainer}>
            <div className={styles.profileHeader}>
              <motion.p className={styles.designation} variants={childVariants}> 
                FOUNDER
              </motion.p>
              <motion.h2 className={styles.founderName} variants={childVariants}>
                Mir Yousuf 
                <span className={styles.degrees}>(BDM)</span>
              </motion.h2>
            </div>
            <div className={styles.profileHeader}>
              <motion.p className={styles.designation} variants={childVariants}>
                CO-FOUNDER
              </motion.p>
              <motion.h2 className={styles.founderName} variants={childVariants}>
                Afreen Fathima <br />
                <span className={styles.degrees}>BA,B.Ed.,MA,(LL.B)</span>
              </motion.h2>
            </div>
          </div>
          <motion.h3 className={styles.quote} variants={childVariants}>
            "A helping hand today can change a life forever..."
          </motion.h3>

          <motion.p className={styles.highlightText} variants={childVariants}>
            “We ourselves feel that what we are doing is just a drop in the ocean.
            But the ocean would be less because of that missing drop”.
          </motion.p>

          <motion.div className={styles.biography} variants={childVariants}>
            <p>
              Mir Yousuf founded <strong>Z Foundation</strong> with a deep-seated passion for social service
              and a vision to create a more equitable society. His leadership is driven by the belief
              that every individual has the power to make a difference, and through collective action,
              we can address the most pressing challenges facing our communities. From this vision,
              the<strong> Z Foundation</strong> was born—not just as an organization, but as a movement dedicated to empowering women,
              educating children,supporting families,and building communities that can stand with pride.
            </p>

          </motion.div>

          {/* Social Icons with a pop-up effect */}
          <motion.div className={styles.socialIcons} variants={childVariants}>
            <button className={styles.iconCircle}><FaYoutube /></button>
            <button className={styles.iconCircle1}><FaFacebookF /></button>
            <button className={styles.iconCircle2}><FaInstagram /></button>
          </motion.div>
        </motion.div>

      </motion.div>
    </section>
  );
};

export default FounderSection;